import React, { useRef } from 'react';
import { Box, Divider } from '@mui/material';
import {
  FormProps,
  FormHeader,
  ClientNameField,
  DocumentUploadArea,
  FactsDescriptionField,
  PieceToRebutField,
  AudioRecordingSection,
  WritingStyleSelector,
  InfoTip,
} from './shared';

// Opções para agravo interno
const PECAS_AGRAVADAS = [
  'Decisão Monocrática',
  'Decisão do Relator',
  'Decisão que Negou Seguimento',
  'Decisão que Indeferiu Liminar',
  'Decisão que Deferiu Liminar',
  'Decisão de Inadmissibilidade',
  'Outro'
];

const AgravoInternoForm: React.FC<FormProps> = ({
  documentType,
  values,
  onChange,
  uploadedFiles,
  onFileUpload,
  onFileRemove,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedStyle, setSelectedStyle] = React.useState(values.estilo_escrita || 'padrao');

  const handleFieldChange = (fieldId: string, value: any) => {
    onChange({
      ...values,
      [fieldId]: value,
    });
  };

  const handleRecordingComplete = (audioBlob: Blob) => {
    const audioFile = new File([audioBlob], `audio_${Date.now()}.webm`, {
      type: 'audio/webm',
    });
    onFileUpload([audioFile]);
  };

  return (
    <Box>
      <FormHeader 
        documentType={documentType}
        customTitle="Agravo Interno"
        customDescription="Recurso contra decisões monocráticas do relator"
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* 1. Nome do Cliente */}
        <ClientNameField
          value={values.nome_cliente || ''}
          onChange={(value) => handleFieldChange('nome_cliente', value)}
        />

        {/* 2. Upload de Documentos */}
        <DocumentUploadArea
          uploadedFiles={uploadedFiles}
          onFileUpload={onFileUpload}
          onFileRemove={onFileRemove}
          suggestedDocs="Decisão agravada e Processo na íntegra."
          fileInputRef={fileInputRef as React.RefObject<HTMLInputElement>}
        />

        {/* 3. Descrição dos Fatos (Opcional) */}
        <FactsDescriptionField
          value={values.fatos_caso || ''}
          onChange={(value) => handleFieldChange('fatos_caso', value)}
          placeholder="Descreva os motivos do agravo, os erros da decisão monocrática, argumentos jurídicos..."
        />

        {/* 4. Decisão agravada */}
        <PieceToRebutField
          value={values.peca_rebater || 'Decisão Monocrática'}
          onChange={(value) => handleFieldChange('peca_rebater', value)}
          otherValue={values.peca_rebater_outro || ''}
          onOtherChange={(value) => handleFieldChange('peca_rebater_outro', value)}
          options={PECAS_AGRAVADAS}
          label="Indique a peça do processo que deseja rebater ou responder:"
        />

        {/* Gravação de Áudio */}
        <AudioRecordingSection
          onRecordingComplete={handleRecordingComplete}
          description="Grave um áudio descrevendo os fundamentos do agravo que a IA irá transcrever automaticamente."
        />
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Estilo de Escrita */}
      <WritingStyleSelector
        selectedStyle={selectedStyle}
        onStyleChange={(styleId) => {
          setSelectedStyle(styleId);
          handleFieldChange('estilo_escrita', styleId);
        }}
      />

      <InfoTip message="Anexe obrigatoriamente a decisão monocrática agravada para que a IA possa identificar os fundamentos a serem combatidos e levar a questão ao colegiado." />
    </Box>
  );
};

export default AgravoInternoForm;

